import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import * as yup from "yup";
import { useStyles } from "../../../../../shared/styles/useStyles";
import { AppState } from "../../../../../redux/reducers/rootReducer";
import { IContractingOffice } from "../../../../../redux/types/types";
import { startSetContractingOffice } from "../../../../../redux/actions/correspondenceActions";

function useReceivingOfficeForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { productionOffices } = useSelector((state: AppState) => state.trd);

  const { contractingOffice } = useSelector(
    (state: AppState) => state.correspondence
  );

  const initialValues = {
    productionOfficePQRSCiu: contractingOffice?.productionOfficePQRSCiu ?? "",
  };

  const validationSchema = yup.object({
    productionOfficePQRSCiu: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredOffice" })}`),
  });

  const submit = async ({
    productionOfficePQRSCiu,
  }: {
    productionOfficePQRSCiu: string;
  }) => {
    const contractingOfficeData: IContractingOffice = {
      ...contractingOffice,
      productionOfficePQRSCiu: productionOfficePQRSCiu,
    } as IContractingOffice;

    await dispatch(
      startSetContractingOffice(
        contractingOfficeData,
        "officeSuccessfully",
        "officeError"
      )
    );
  };

  return {
    classes,
    productionOffices,
    initialValues,
    submit,
    validationSchema,
  };
}

export default useReceivingOfficeForm;
